<h1 mat-dialog-title>Fill Organisation Details</h1>
<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
<div mat-dialog-content>
  <form [formGroup]="Form">

    <!-- Org Name field -->
    <mat-form-field appearance="outline">
      <!-- <mat-label>Name</mat-label> -->
      <input matInput formControlName="name" required placeholder="Name *">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <input matInput formControlName="orgCode" required placeholder="Organisation Code *" [(ngModel)]="organisationCode" [disabled]="orgCodeControl.disabled">
    </mat-form-field>

    <!-- Status field -->
    <mat-slide-toggle formControlName="active">Status</mat-slide-toggle>
	<br>
	<mat-slide-toggle formControlName="progressBarLock">Video Progress Bar Lock</mat-slide-toggle>

    <div style="margin-top: 25px;">
      <!-- <div *ngIf="f.icon.value">
              <img [src]="f.icon.value"
              alt="Subject Icon",
              class="icon-image"
              />
            </div> -->
      <input type="file" (change)="onFileChange($event)" accept=".png, .jpg, .jpeg" required />
      <!-- <mat-error *ngIf="isImage">Please upload an image.</mat-error> -->
    </div>
  </form>




</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button cdkFocusInitial (click)="saveBtn()">Save</button>
</div>